import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import { VenueTagsSuccessResponse } from "./api-response/VenueTagsSuccessResponse";
import { map } from "rxjs/operators";

export class ApiVenueTag {
  constructor(private apiEndpoint: string) {}

  listByOrganization(
    token: string,
    organization: string
  ): Observable<VenueTagsSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/venue-tags`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
